/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2023 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2023 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useDispatch } from 'react-redux';
import ServiceChip from './ServiceChip';
import { timeSeriesActions } from '../../../store';
import type { ServiceFilterChipsObject } from '../../../store/types';

export interface ServiceChipConnectProps {
  service: ServiceFilterChipsObject;
  isAllSelected: boolean;
  panelId: string;
}

export const ServiceChipConnect: React.FC<ServiceChipConnectProps> = ({
  service,
  isAllSelected,
  panelId,
}: ServiceChipConnectProps) => {
  const dispatch = useDispatch();

  const { serviceId } = service;
  const toggleChip = (): void => {
    if (service.enabled) {
      if (isAllSelected) {
        dispatch(
          timeSeriesActions.setOnlyThisServiceFilterChipSelected({
            serviceId,
            panelId,
          }),
        );
        return;
      }
      dispatch(
        timeSeriesActions.setServiceFilterChipUnselected({
          serviceId,
          panelId,
        }),
      );
      return;
    }
    dispatch(
      timeSeriesActions.setServiceFilterChipSelected({
        serviceId,
        panelId,
      }),
    );
  };
  return (
    <ServiceChip
      isDisabled={service.isLoading}
      isSelected={isAllSelected ? false : service.enabled}
      service={service}
      toggleChip={toggleChip}
    />
  );
};

export const AllChipConnect: React.FC<{
  isAllSelected: boolean;
  panelId: string;
}> = ({ isAllSelected, panelId }) => {
  const dispatch = useDispatch();

  return (
    <ServiceChip
      isSelected={isAllSelected}
      toggleChip={(): void => {
        if (!isAllSelected) {
          dispatch(
            timeSeriesActions.setAllServiceFilterChipSelected({ panelId }),
          );
        }
      }}
    />
  );
};
